<template>
  <CButton
    class="c-icon-button"
    :class="{
      'c-icon-button--round': shape === 'round',
    }"
    :is-disabled="isDisabled"
    :variant="variant"
    :size="size"
    @click="handleClick"
  >
    <slot />
    <div
      v-if="isLoading"
      class="c-icon-button__loader"
    >
      <CSpinner size="small" />
    </div>
    <CIcon
      v-else
      :class="iconClasses"
      :name="name"
      :size="iconSize ?? size"
    />
    <slot name="right" />
  </CButton>
</template>

<script setup lang="ts">
import CIcon from '../../atoms/CIcon'
import CButton from '../../atoms/CButton'
import CSpinner from '../../atoms/CSpinner'

interface Props {
  name: string
  iconClasses?: string
  variant?:
    | 'primary'
    | 'secondary'
    | 'plain'
    | 'plain-light'
    | 'outlined'
    | 'outlined--clicked'
    | 'href'
    | 'to'
    | 'green'
    | 'secondary-no-border'
    | 'secondary--clicked'
  size?: 'small' | 'medium' | 'large' | 'xl'
  iconSize: 'xs' | 'small' | 'medium' | 'large'
  shape?: 'round' | ''
  isDisabled?: boolean
  isLoading?: boolean
}

withDefaults(defineProps<Props>(), {
  iconClasses: '',
  variant: 'primary',
  size: 'medium',
  iconSize: undefined,
  shape: '',
  isDisabled: false,
  isLoading: false,
})

const emit = defineEmits<{
  (e: 'click', event: Event): void
}>()

const handleClick = (event: Event) => {
  emit('click', event)
}
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CIconButton',
})
</script>
